import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import Auth from "./Auth";
import Routing from "./Routing";
import SocketProvider from "./Socket";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

const App: React.FC = () => {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Auth>
        <SocketProvider>
          <Routing />
        </SocketProvider>
      </Auth>
    </ThemeProvider>
  );
};

export default App;
